import React, { createContext, useContext, useState, useEffect } from "react";
import { useCookies } from "react-cookie";
import axios from "axios";
import Swal from "sweetalert2";

const UserContext = createContext();

export const UserProvider = ({ children }) => {

    axios.defaults.withCredentials = true;

    const [cookies, setCookie, removeCookie] = useCookies(["user"]);
    const [user, setUser] = useState(cookies.user || null);

    const alerta = (mensage, icon) => {
        Swal.close();
        Swal.fire({
            title: mensage,
            icon: icon,
            text: "",
            showConfirmButton: false,
            timer: 1500
        });
    }

    const login = (userData) => { 
        // console.log(userData);

        if(userData.rol == "inhabilitado"){
            alerta("Usuario Inhabilitado", "warning")
            logout()
        }

               
        setCookie("user", userData.id, { path: "/", maxAge: 99000000 }); // Guardar usuario en cookies
        setCookie("rol", userData.rol, { path: "/", maxAge: 99000000 }); // Guardar usuario en cookies
        setCookie("nombre", userData.nombre, { path: "/", maxAge: 99000000 }); // Guardar usuario en cookies
        setCookie("permisos", JSON.stringify(userData.permisos), { path: "/", maxAge: 99000000 }); // Guardar permisos como JSON en cookies
        setCookie("infoUser", JSON.stringify(userData), { path: "/", maxAge: 99000000 }); // Guardar permisos como JSON en cookies
        setUser(userData); // Actualizar el estado del usuario
    };

    const logout = () => {
        removeCookie("user", { path: "/" });
        removeCookie("rol", { path: "/" });
        removeCookie("nombre", { path: "/" });
        removeCookie("permisos", { path: "/" });
        removeCookie("infoUser", { path: "/" });
        setCookie("proyecto", 0, { path: "/", maxAge: 3600 }); // Guardar usuario en cookies
        setUser(null);
        axios.get("https://apimedidas.ahouseinterior.com/logout.php", { withCredentials: true }) // Llama al backend para destruir la sesión
        .catch((error) => {
            console.error("Error al cerrar sesión en el servidor:", error);
        });
    };

    // Actualizar estado del usuario si cambian las cookies
    // useEffect(() => {
    //     setUser(cookies.user || null);
    // }, [cookies]);

    return (
        <UserContext.Provider value={{ user, login, logout }}>
            {children}
        </UserContext.Provider>
    );
};

export const useUser = () => useContext(UserContext);
